export * from './uppercase.pipe';
